<!--
 * @Description 
-->
<template>
  <div>
    <div class="handel-header">
      <el-button
        type="primary"
        @click="addClick">新建回款计划</el-button>
    </div>
    <crm-table
      ref="planTable"
      :data="planList"
      border
      stripe
      style="width: 100%;">
      <el-table-column
        v-for="(item, index) in planFieldList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width"
        show-overflow-tooltip/>
      <el-table-column
        label="操作"
        fixed="right"
        :min-width="120">
        <template slot-scope="{ row, $index }">
          <el-button
            type="primary-text"
            style="padding: 0;"
            @click.native="handleFile('edit', row, $index )">编辑</el-button>
          <el-button
            type="primary-text"
            style="padding: 0;"
            @click.native="handleFile('delete', row, $index )">删除</el-button>
        </template>
      </el-table-column>
    </crm-table>
    <ReceivablesPlanCreate
      v-if="isCreate"
      crm-type="receivablesPlan"
      :action="createActionInfo"
      @draft="saveSuccess"
      @hiddenView="isCreate = false"
      @close="isCreate = false"/>
  </div>
</template>
<script type="text/javascript">
import ReceivablesPlanCreate from '@/wkcrmViews/crm/receivablesPlan/Create'

export default {
  name: 'XhPlan',

  components: {
    ReceivablesPlanCreate
  },

  props: {
    /** 没有值就是全部类型 有值就是当个类型 */
    crmType: {
      type: String,
      default: ''
    },
    dataValue: {
      type: [Array],
      default: () => {
        return {}
      }
    }
  },
  
  data() {
    return {
      isCreate: false,
      planData: [],
      planList: [],
      planFieldList: [],
      createActionInfo: {
        type: 'draft'
      },
    }
  },
  mounted() {
    this.planFieldList = [
      // { prop: 'num', width: '80', label: '期数' },
      { prop: 'money', width: '160', label: '计划回款金额' },
      { prop: 'returnDate', width: '160', label: '计划回款日期' },
      { prop: 'returnType', width: '120', label: '计划回款方式' },
      { prop: 'remind', width: '120', label: '提前几日提醒' },
      { prop: 'remark', width: '200', label: '备注' }
    ];
  },
  computed: {},
  watch: {
    dataValue: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('%c [ val ]-105', 'font-size:13px; background:pink; color:#bf2c9f;', val)
        this.planData = val || [];
        this.planList = val && Array.isArray(val) ? val.map((e) => e.entity) : [];
      },
    }
  },
  methods: {

    /**
     * 删除操作
     */
    removeItem(index) {
      const removeItem = this.planList.splice(index, 1);

    },

    /**
     * 添加click
     */
    addClick() {
      this.createActionInfo = {
        type: 'draft',
        crmType: this.crmType,
        data: {}
      },
      this.isCreate = true
    },

    /**
     * 添加成功
     */
    saveSuccess(data) {
      if (this.createActionInfo.type === 'draft') {
        this.planData.push(data);
        this.planList.push(data.entity);
      } else {
        const index = this.createActionInfo.editIndex;
        this.planData[index] = {
          ...data,
        };
        this.$set(this.planList, index, {
          ...data.entity
        });
      }
      this.isCreate = false;
      this.valueChange();
    },

    handleFile(type, row, index) {
      console.log(row, index);
      if (type === 'edit') {
        this.createActionInfo = {
          type: 'updateDraft',
          data: {
            ...row
          },
          editIndex: index
        };
        this.isCreate = true;
      } else {
        this.$confirm('您确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.planData.splice(index, 1);
          this.planList.splice(index, 1);
          this.valueChange();
        }).catch(() => {});
      }
    },
    valueChange() {
      this.$emit('value-change', {
        value: this.planData
      });
    }
  },

}
</script>
<style lang="scss" scoped>
.handel-header {
  overflow: hidden;
  text-align: right;

  button {
    margin-bottom: 10px;
  }
}
.error-info {
  font-size: 12px;
  color: #F56C6C;
  margin-top: 4px;
}

</style>
